/* global elementorFrontend, Swiper */
import $ from 'jquery';

export const sliderTrainingQuote = () => {
	const parentClass = '.mi-training-quote-wrapper';

	if (!$(parentClass).length) return;

	const initSwiper = function ($container) {
		const $slider = $container.find('.mi-training-quote-slider');
		if (!$slider.length) return;

		if ($slider.data('swiper')) {
			try {
				$slider.data('swiper').destroy(true, true);
			} catch (e) {
				// ignore cleanup error
			}
			$slider.removeData('swiper');
		}
		$slider.find('.swiper-slide-duplicate').remove();

		if ($slider.data('swiper-initializing')) return;
		$slider.data('swiper-initializing', true);

		const slideCount = $slider.find('.swiper-slide').length;
		const isAutoplay = $container.data('autoplay') === true || $container.data('autoplay') === 'true';
		const autoSpeed = parseInt($container.data('autoplay-speed')) || 5000;
		const isLoop = slideCount > 1 && ($container.data('loop') === true || $container.data('loop') === 'true');

		const params = {
			slidesPerView: 1,
			spaceBetween: 24,
			loop: isLoop,
			grabCursor: slideCount > 1,
			watchSlidesProgress: true,
			watchOverflow: true,
			observer: true,
			observeParents: true,
			autoplay: (isAutoplay && slideCount > 1) ? { delay: autoSpeed, disableOnInteraction: false } : false,
			pagination: {
				el: $container.find('.mi-training-quote-pagination')[0],
				clickable: true,
			},
			navigation: {
				nextEl: $container.find('.mi-training-quote-next')[0],
				prevEl: $container.find('.mi-training-quote-prev')[0],
			},
		};

		if (typeof elementorFrontend !== 'undefined' && elementorFrontend.utils && elementorFrontend.utils.swiper) {
			const asyncSwiper = elementorFrontend.utils.swiper;
			new asyncSwiper($slider, params).then(function (newSwiperInstance) {
				$slider.data('swiper', newSwiperInstance);
				$slider.removeData('swiper-initializing');
			});
		} else if (typeof Swiper !== 'undefined') {
			const newSwiper = new Swiper($slider[0], params);
			$slider.data('swiper', newSwiper);
			$slider.removeData('swiper-initializing');
		} else {
			$slider.removeData('swiper-initializing');
		}
	};

	$(window).on('elementor/frontend/init', function () {
		if (typeof elementorFrontend !== 'undefined' && elementorFrontend.hooks) {
			elementorFrontend.hooks.addAction(
				'frontend/element_ready/training-quote.default',
				function ($element) {
					initSwiper($element);
				}
			);
		}
	});

	$(parentClass).each(function () {
		initSwiper($(this));
	});
};

try {
	sliderTrainingQuote();
} catch (error) {
	console.warn(error);
}
